import React from "react";

const LoadingIndicator = ({ loading, tempRespon, themes }) => {
    if (loading && tempRespon === "") {
        return (
            <div className="loading-search rounded-2xl">
                <span></span>
            </div>
        );
    } else if (loading && tempRespon !== "") {
        return (
            <div className="mt-3 place-self-start text-left">
                <div
                    className="mt-3 p-3 rounded-2xl"
                    style={{
                        backgroundColor: "white",
                        color: themes.secondryFontColor,
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                    }}
                >
                    <div className="break-words text-md">{tempRespon}</div>
                </div>
            </div>
        );
    }
    return null;
};

export default LoadingIndicator;
